import apiGetRequest from './base/api-get-request'

const getSharedCustomerDetail = (customerId, { email, shareCode }) => {
    const params = new URLSearchParams()

    if (email) {
        params.append('email', email)
    }

    if (shareCode) {
        params.append('shareCode', shareCode)
    }

    const queryString = params.toString()
    const url = queryString
        ? `/customer/${customerId}?${queryString}`
        : `/customer/${customerId}`

    return apiGetRequest(url)()
}

export default getSharedCustomerDetail